import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import React from 'react';
import styled from 'styled-components';
import Divider from '@material-ui/core/Divider';


const Container = styled.div`
    min-width:680px;
    display:flex;
    flex-direction:column;

    padding-bottom:40px;
`;

const ContainerHeader = styled.div`
    width:100%;
    color: white;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    padding:20px;
    height:80px;
    background-color:RGB(48, 74, 87);
    display:flex;
    align-items:center;
`;

const ContainerSubtitle = styled.div`
padding-left:20px;
padding-top:30px;
font-size: 15px;
font-weight: 500;
`;

const ContainerBody = styled.div`
padding:20px;
font-size: 15px;
font-weight: 100;
`;

const ContainerFooter = styled.div`
    width:100%;
    display:flex;
    height:40px;
    justify-content:flex-end;
    padding-right:20px;    
    
`;


const ButtonContainer = styled.div`
    padding:20px;

`;


class ConfirmationDialog extends React.Component {



    render()
    {
        const {title,subtitle,body,cancelText="Cancel",confirmText="Okay",open,onCancel=()=>{},onConfirm=()=>{}} = this.props;


        return (
            <Dialog maxWidth='xl' open={open}>
                <Container>
                    <ContainerHeader>{title}</ContainerHeader>
                    <ContainerSubtitle>{subtitle}</ContainerSubtitle>
                    <ContainerBody>{body}</ContainerBody>
                    <Divider/>
                    <ContainerFooter>
                        <ButtonContainer>
                            <Button variant="outlined" color="primary" onClick={()=>{
                                onCancel();
                            }}>{cancelText}</Button>
                        </ButtonContainer>

                        <ButtonContainer>
                            <Button variant="contained" color="primary" onClick={()=>{
                                onConfirm();
                            }}>{confirmText}</Button>
                        </ButtonContainer>
                  </ContainerFooter>
                </Container>
            </Dialog>
        )
    }

}

export default ConfirmationDialog;